import {
  getSandboxArtifactDownload,
  getSandboxArtifactPreview,
} from "@/lib/data/requests/sandbox-artifacts";
export const sandboxArtifactDownloadOptions = (id: string) => ({
  mutationFn: (disposition: "inline" | "attachment") =>
    getSandboxArtifactDownload(id, disposition),
});

export const sandboxArtifactPreviewOptions = (id: string) => ({
  queryKey: ["sandbox-artifact-preview", id],
  queryFn: () => getSandboxArtifactPreview(id),
  staleTime: 60_000,
  gcTime: 60_000,
  retry: false,
});
